import React from 'react';
import { connect } from 'react-redux';
import { setFiltroSeller } from '../../actions/sellersActions';

class FiltroSellers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            razonSocial: this.props.filtro?.razonSocial ?? ""
        }
    };

    handleChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        this.props.setFiltroSeller({ ...this.props.filtro, [name]: value });
    }

    onSubmit = async (event) => {
        event.preventDefault();
        this.props.getSellers();
        this.props.setFiltroSeller({ ...this.props.filtro, numeroPagina: 1 });
    }

    onClear = () => {
        this.setState({ razonSocial: "" });
        this.props.clearFilter();
    }

    render() {
        return (
            <div className="card card-body filter-card">
                <form
                    className="row align-items-center justify-content-evenly form-material"
                    onSubmit={this.onSubmit}
                    onReset={this.onClear}
                >
                    <div className="col-12 col-sm-3 pb-2">
                        <label className="label-oscura">Razon Social</label>
                        <input
                            type="text"
                            name="razonSocial"
                            className="form-control"
                            onChange={this.handleChange}
                            value={this.state.razonSocial}
                        />
                    </div>

                    <div className="col-12 col-sm-6 text-center text-sm-end mt-sm-3">
                        <button
                            type="submit"
                            className="btn btn-sm btn-grey mt-2 mt-sm-0"
                        >
                            Buscar
                        </button>

                        <button
                            type="reset"
                            className="btn btn-sm btn-grey ms-2 ms-sm-2 mt-2 mt-sm-0"
                        >
                            Limpiar
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}


const mapStateToProps = state => ({
    sellers: state.sellers.sellers,
    filtro: state.sellers.filtro
});

export default connect(mapStateToProps, { setFiltroSeller })(FiltroSellers);